import React, { useEffect, useContext, useState } from 'react';
import { Link } from 'react-router-dom';
import { AppSettings } from './../../config/app-settings.js';
import { Icon } from '@iconify/react';
import { Tooltip } from 'bootstrap';

function PosKitchenOrder() {
	const context = useContext(AppSettings);
	const [time] = useState(getTime());
	const [orderData, setOrderData] = useState();
	var tooltip = [];
	
	function checkTime(i) {
		if (i < 10) {i = "0" + i};
		return i;
	}
	
	function getTime() {
		var today = new Date();
		var h = today.getHours();
		var m = today.getMinutes();
		var a;
		m = checkTime(m);
		a = (h > 11) ? 'pm' : 'am';
		h = (h > 12) ? h - 12 : h;
	
		setTimeout(() => {
			getTime();
		}, 500);
		return h + ":" + m + a;
	}
	
	function getTotalCompletedItems(items) {
		var count = 0;
		for (var i = 0; i < items.length; i++) {
			if (items[i].status === 'Completed') {
				count++;
			}
		}
		return count;
	}
  
	useEffect(() => {
		context.setAppHeaderNone(true);
		context.setAppSidebarNone(true);
		context.setAppContentClass('p-0');
		
		var elm = document.querySelectorAll('.pos [data-bs-toggle="tooltip"]');
		for (var i = 0; i < elm.length; i++) {
			var t = new Tooltip(elm[i]);
			tooltip.push(t);
		}
		
		fetch('/quantum-react/assets/data/pos/kitchen-order.json').then(res => res.json()).then((result) => { setOrderData(result); });
		
		return () => {
			context.setAppHeaderNone(false);
			context.setAppSidebarNone(false);
			context.setAppContentClass('');
			
			if (tooltip) {
				for (var i = 0; i < tooltip.length; i++) {
					tooltip[i].dispose();
				}
			}
			const elements = document.querySelectorAll('.tooltip');
			elements.forEach(el => {
				el.remove();
			});
		};
		
		// eslint-disable-next-line
	}, []);

	return (
		<div className="pos pos-vertical pos-with-header" id="pos">
			<div className="pos-container">
				<div className="pos-header">
					<div className="logo">
						<Link to="/">
							<div className="logo-img"><Icon icon="material-symbols-light:food-bank" /></div>
							<div className="logo-text">FOOD BANK</div>
						</Link>
					</div>
					<div className="time" id="time">{ time }</div>
					<div className="nav">
						<div className="nav-item">
							<Link to="/pos/counter-checkout" data-bs-toggle="tooltip" data-bs-placement="bottom" data-bs-title="Counter Checkout" className="nav-link">
								<div className="nav-icon">
									<Icon icon="material-symbols-light:shopping-cart-checkout-sharp" />
								</div>
							</Link>
						</div>
						<div className="nav-item">
							<Link to="/pos/kitchen-order" data-bs-toggle="tooltip" data-bs-placement="bottom" data-bs-title="Kitchen Order" className="nav-link active">
								<div className="nav-icon">
									<Icon icon="material-symbols-light:order-approve-outline-sharp" />
								</div>
							</Link>
						</div>
						<div className="nav-item">
							<Link to="/pos/table-booking" data-bs-toggle="tooltip" data-bs-placement="bottom" data-bs-title="Table Booking" className="nav-link">
								<div className="nav-icon">
									<Icon icon="material-symbols-light:calendar-month-outline-sharp" />
								</div>
							</Link>
						</div>
						<div className="nav-item">
							<Link to="/pos/menu-stock" data-bs-toggle="tooltip" data-bs-placement="bottom" data-bs-title="Menu Stock" className="nav-link">
								<div className="nav-icon">
									<Icon icon="material-symbols-light:inventory-2-outline-sharp" />
								</div>
							</Link>
						</div>
					</div>
				</div>
				
				<div className="pos-content">
					<div className="pos-content-container p-0">
						{orderData && orderData.length > 0 ? (orderData.map((order, index) => (
							<div className="pos-task" key={index}>
								<div className="pos-task-info fs-10px">
									<div className="h5 mb-1">Table {order.tableNo}</div>
									<div className="mb-4">Order No: #{order.orderNo}</div>
									<div className="mb-2">
										<span className={'badge fs-10px text-uppercase' +
											((order.orderStatus !== 'Completed') ? ' bg-theme text-theme-color' : '') + 
											((order.orderStatus === 'Completed') ? ' text-bg-secondary' : '')
										}>{order.orderType}</span>
									</div>
									{order.orderTime && (<div className={((order.urgent) ? 'text-danger fw-bold' : '')}>{order.orderTime} time</div>)}
									{order.totalOrderTime && (<div>All dish served<br />{ order.totalOrderTime } total time</div>)}
								</div>
								<div className="pos-task-body">
									<div className="fs-6 mb-3 text-white">
										Completed: ({getTotalCompletedItems(order.items)}/{order.items.length})
									</div>
									<div className="row gx-4">
										{order.items && order.items.length > 0 ? (order.items.map((item, index) => (
											<div className="col-xl-2 col-lg-3 col-md-4 col-6 mb-5 mb-lg-0" key={index}>
												<div className={'pos-task-product' + ((item.status === 'Completed' || item.status === 'Cancelled') ? ' completed' : '')}>
													<div className="pos-task-product-img">
														<div className="cover" style={{backgroundImage: 'url('+ item.image +')'}}></div>
														{item.status === 'Completed' && (<div className="caption"><div>Completed</div></div>)}
														{item.status === 'Cancelled' && (<div className="caption"><div>Cancelled</div></div>)}
													</div>
													<div className="pos-task-product-info">
														<div className="flex-1">
															<div className="d-flex mb-1">
																<div className="fs-6 flex-1 text-white fw-semibold">{item.title}</div>
																<div className="fs-6 text-white fw-semibold">x{item.quantity}</div>
															</div>
															{item.note.length > 0 && (item.note.map((note, index) => (
																<div className="text-body text-opacity-75 small" key={index}> - {note}</div>
															)))}
														</div>
													</div>
													<div className="pos-task-product-action">
														<a href="#/" className={'btn btn-theme btn-sm' + ((item.status === 'Completed' || item.status === 'Cancelled') ? ' disabled' : '')}>Complete</a>
														<a href="#/" className={'btn btn-secondary btn-sm' + ((item.status === 'Completed' || item.status === 'Cancelled') ? ' disabled' : '')}>Cancel</a>
													</div>
												</div>
											</div>
										))) : (
											<div className="col-12">
												No records found
											</div>
										)}
									</div>
								</div>
							</div>
						))) : (
							<div className="px-3 py-5 text-center">
								No order found
							</div>
						)}
					</div>
				</div>
			</div>
		</div>
	)
}

export default PosKitchenOrder;